<template>
    <div>
        <div class="feedback_view">
            <div class="title_name">调查问卷</div>
            <div class="weui-cells__title feedback_mr">复印病历用于什么报销？</div>
            <div class="line"></div>
            <div class="data_list" v-for="item in radioItems" :key="item.name">
                <input type="radio" class="check_box tui-checkbox" name='checkboxinput' @click="checkedname(item.name)">
                <label> {{item.name}}</label>
            </div>
        </div>
        <div class='commit_btn'>
            <button class="" type="primary" v-if="disabled" @click="commit">提交</button>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { Toast, Notify } from "vant";
Vue.use(Toast).use(Notify);
export default {
  data() {
    return {
      radioItems: [
        { name: "医疗保险", value: "0", checked: false },
        { name: "商业保险", value: "1", checked: false },
        { name: "其他", value: "2", checked: false }
      ],
      toptipsHidden: true,
      disabled: true,
      selectname: ""
    };
  },
  created() {
    // let wxId = localStorage.getItem("wxId");
    // let userId = localStorage.getItem("userId");
    // let token = localStorage.getItem("token");
    // let requestId = localStorage.getItem("requestId");
    // console.log(wxId, userId);
    // const params = {
    //   wxId: wxId,
    //   userId: userId,
    //   token: token,
    //   desc: "",
    //   requestId: requestId
    // };
    // this.questionFeeback(params);
  },
  methods: {
    questionFeeback(params) {
      this.$server.questionFeeback(params).then(data => {
        //   data.result = 2
        if (data.result == 1) {
          console.log(data);
            Toast({
            type: "success",
            message: "提交成功",
            onClose: () => {
            console.log("执行OnClose函数");
            this.$router.push({
                path: "/home"
            });
            }
        });
          // this.hosResultList = data.hospitals
          // console.log('全部医院名称')
        }else{
            console.log('网络不好')
            Toast('网络错误请稍后重试');
        }
      });
    },
    checkedname(name) {
      console.log(name);
      this.selectname = name;
    },
    commit() {
        if(this.selectname == ''){
            Notify({
					type: 'warning',
					message: '请选择复印用途'
				});
        }else{
            console.log(this.selectname);
            let wxId = localStorage.getItem("wxId");
            let userId = localStorage.getItem("userId");
            let token = localStorage.getItem("token");
            let requestId = localStorage.getItem("requestId");
            // let requestId = this.$route.params.requestId;
            const params = {
                wxId: wxId,
                userId: userId,
                token: token,
                desc: this.selectname,
                requestId: requestId
            };
            this.questionFeeback(params);
        }
      
    }
  }
};
</script>
<style>
.feedback_view {
  background-color: white;
  padding: 15px 0 0 15px;
}
.title_name{
  font-size: 24px;
}
.feedback_mr {
  margin-bottom: 15px;
  font-size: 20px;
}

.commit_btn {
  position: fixed;
  bottom: 80px;
  width: 90%;
  z-index: 2;
  background: #1aad19;
  color: white;
  text-align: center;
  height: 50px;
  margin-left: 5%;
  line-height: 50px;
  border-radius: 6px;
}
.data_list {
  line-height: 50px;
  border-bottom: 1px solid #eeeeee;
}
.tui-checkbox:checked {
  background: #1aad19;
  border: solid 1px #1aad19;
}
.tui-checkbox {
  width: 1.5rem;
  height: 1.5rem;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 0.8rem;
  margin: 0 10px 0 0;
  padding: 0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  top: 12px;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}
.tui-checkbox:checked::after {
  content: "";
  top: 0.28rem;
  left: 0.24rem;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 0.45rem;
  width: 0.7rem;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>


